import React, { SVGProps } from 'react';

const HoldingsDepositIcon = ({
  className,
  style,
  width,
  height,
  fill,
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width || '20'}
    height={height || '20'}
    fill={fill || 'none'}
    className={className}
    style={style}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_740_1406)">
      <path
        d="M11.666 9.16666V6.66666L7.49935 10L11.666 13.3333V10.8333H19.166V9.16666H11.666ZM17.951 12.5H16.181C15.5993 13.9326 14.5379 15.1185 13.1784 15.8549C11.8189 16.5914 10.2458 16.8326 8.72806 16.5373C7.21036 16.242 5.84242 15.4285 4.85824 14.236C3.87406 13.0435 3.33479 11.5462 3.33268 10C3.33182 8.45221 3.86953 6.95236 4.8536 5.75768C5.83766 4.56301 7.20675 3.74796 8.72604 3.45234C10.2453 3.15672 11.8201 3.39895 13.1804 4.13748C14.5406 4.87601 15.6015 6.06481 16.181 7.5H17.951C16.8893 4.11916 13.731 1.66666 9.99935 1.66666C5.39685 1.66666 1.66602 5.3975 1.66602 10C1.66602 14.6025 5.39685 18.3333 9.99935 18.3333C13.731 18.3333 16.8893 15.8808 17.951 12.5Z"
        fill="var(--primaryTheme)"
        stroke="#191A1F"
        strokeWidth="0"
      />
    </g>
    <defs>
      <clipPath id="clip0_740_1406">
        <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20 0)" />
      </clipPath>
    </defs>
  </svg>
);

export default HoldingsDepositIcon;
